/**
 * Tailwind CSS implementation of Select component
 * Uses Seeds select CSS classes from select.css
 */

import * as React from "react";
import Icon from "@sproutsocial/seeds-react-icon";
import type { TypeSelectProps } from "./SelectTypes";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export const SelectTailwind = ({
  id,
  name,
  children,
  defaultValue,
  value,
  required,
  isInvalid,
  onChange,
  autoFocus,
  disabled,
  ariaLabel,
  ariaDescribedby,
  size = "default",
  qa = {},
  inputProps = {},
  className,
  ...rest
}: TypeSelectProps) => {
  const handleChange = (e: React.SyntheticEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div
      className={cn(
        "seeds-select",
        `seeds-select-${size}`,
        {
          "seeds-select-invalid": !!isInvalid,
          "seeds-select-disabled": !!disabled,
        },
        className
      )}
      {...(rest as any)}
    >
      <select
        className="seeds-select-input"
        id={id}
        name={name}
        aria-label={ariaLabel}
        aria-describedby={ariaDescribedby}
        defaultValue={defaultValue}
        value={value}
        required={required}
        autoFocus={autoFocus}
        disabled={disabled}
        onChange={handleChange}
        data-qa-select={name || ""}
        data-qa-select-value={value || "unselected"}
        data-qa-select-isrequired={required === true}
        data-qa-select-isdisabled={disabled === true}
        {...qa}
        {...inputProps}
      >
        {children}
      </select>

      <span className={cn("seeds-select-arrow", `seeds-select-arrow-${size}`)}>
        <Icon
          name="chevron-down-outline"
          fixedWidth
          size={size === "large" ? "medium" : "small"}
          aria-hidden
        />
      </span>
    </div>
  );
};

SelectTailwind.displayName = "SelectTailwind";
